import { render, staticRenderFns } from "./TransactionsExtraIncomeCashregisteroff.vue?vue&type=template&id=0c89e911&"
import script from "./TransactionsExtraIncomeCashregisteroff.vue?vue&type=script&lang=js&"
export * from "./TransactionsExtraIncomeCashregisteroff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports